import React from 'react'
import styles from './BusinessGain.module.css'

export type BusinessGainProps = {
  title: React.ReactNode
  description: React.ReactNode
  leftColumnItems: ReadonlyArray<string>
  wrapperClassName?: string
}

const renderItem = (item: string) => (
  <li className={styles.resultItem}>
    <span className={styles.icon} aria-hidden="true">
      <span className={styles.checkmark}>✓</span>
    </span>
    <span className={styles.itemText}>{item}</span>
  </li>
)

const BusinessGain: React.FC<BusinessGainProps> = ({
  title,
  description,
  leftColumnItems,
  wrapperClassName,
}) => {
  return (
    <section
      className={[
        styles.resultsSection,
        wrapperClassName ? styles[wrapperClassName] : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="container">
        <div className="row g-4 g-lg-5 align-items-center">
          <div className="col-12 col-lg-6">
            <h2 className={styles.title}>{title}</h2>
            <p className={styles.description}>{description}</p>
          </div>

          <div className="col-12 col-lg-6 gx-4 ">
            <div className="row">
              <div className="col-12">
                <ul
                  className={styles.list}
                  aria-label="Operational impact metrics column one"
                >
                  {leftColumnItems.map((item) => (
                    <React.Fragment key={item}>
                      {renderItem(item)}
                    </React.Fragment>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BusinessGain
